module.exports = __webpack_public_path__ + "img/katherine-prescott-wormeley.1cf62c38.png";